'use client';

import { memo, useEffect, useState, useTransition } from 'react';
import { TabInfo } from '../types';

export interface Tab {
  info: TabInfo;
  component: React.ReactNode;
}

interface TabsProps {
  tabs: Array<Tab>;
  tabsAtEnd?: boolean;
  tabsYt?: boolean;
  title?: string;
}

export default function Tabs({ tabs, title, tabsAtEnd = false, tabsYt = false }: TabsProps) {
  const [isPending, startTransition] = useTransition();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (tabIndex: number) => {
    startTransition(() => {
      setSelectedTab(tabIndex);
    });
    const tabHash = tabs[tabIndex].info.hash;
    if (tabHash) {
      window.location.hash = tabHash;
    }
  };

  useEffect(() => {
    // Handle job form code in url
    const hash = window.location.hash.replace('#', '').split('?')[0];
    if (hash && tabs.length) {
      const index = tabs.findIndex((tab) => tab.info.hash === hash);
      if (index !== -1) {
        startTransition(() => {
          setSelectedTab(index);
        });
      }
    }
  }, [tabs]);

  if (!tabs.length && !tabsYt) {
    return null;
  }

  return (
    <div>
      <div className="flex w-full animate-fadeIn border-b lg:pl-6 lg:pr-6">
        {tabsAtEnd && (
          <div className="flex-1">
            <h2 className="p-2">{title}</h2>
          </div>
        )}
        <div role="tablist" className={`flex overflow-x-auto ${!tabsAtEnd ? 'flex-1' : ''}`}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`relative flex h-12 text-nowrap ${index === selectedTab ? 'tab-active' : ''}`}
            >
              <input
                type="radio"
                id="tab1"
                name="my_tabs_1"
                role="tab"
                className={`tab font-Manrope font-bold text-gray-500 ${index === selectedTab ? 'text-neutral-900' : ''} text-xs lg:text-sm`}
                aria-label={tab.info.name}
                onChange={() => handleChange(index)}
              />
              {tab.info.liveIndicator && (
                <span className="block h-[10px] w-[10px] rounded-full bg-ffbb-red"></span>
              )}
            </div>
          ))}
          {tabsYt && (
            <div
              className={`relative flex h-12 text-nowrap ml-auto`}
            >
              <a href={`https://www.youtube.com/@FFBB_officiel/streams`} target={'_blank'} className="tab font-Manrope h-12 font-bold text-gray-500 text-xs lg:text-sm`">
                LIVE VIDÉO
              </a>
            </div>)}
        </div>
        {!tabsAtEnd && (
          <div>
            <h2 className="p-2">{title}</h2>
          </div>
        )}
      </div>
      {tabs && tabs.length && tabs.length > selectedTab &&
      <div className={`animate-fadeIn`} key={selectedTab}>
        {tabs[selectedTab].component}
      </div>}
    </div>
  );
}
